// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "standalone-dialog" + "." + "4fd68f0d" + ".css";
};